<template>

	<div>

		<div class="container">

			<div class="header">Please verify you are human</div>

			<div class="check" @click="openChallenge">

				<div class="checkbox"></div>

				<span>Click to verify</span>

			</div>

			<div style="margin-top:20px;">

				This verification helps ensure the security and performance of this website.

			</div>

			<div class="footer">

				Verification service enabled

			</div>
		</div>

		<div v-if="showOverlay" class="overlay">

			<div class="modal">

				<div class="challenge-header">

					<h2>Select all images containing</h2>

					<p>{{ prompts[promptStage].question }}</p>

				</div>

				<div class="grid">

					<div
						v-for="(img, index) in images"
						:key="index"
						class="image-wrapper"
						:class="{ selected: selected.includes(img) }"
						@click="toggleSelectionImage(img)"
					>

						<div
							v-if="selected.includes(img)"
							class="checkmark"
						>
							✓
						</div>

						<img
							:src="img"
							draggable="false"
						/>

					</div>
				</div>

				<div v-if="error" class="error">
					{{ error }}
				</div>

				<div class="modal-footer">

					<button @click="submitPrompt">VERIFY</button>

				</div>

			</div>

		</div>

		<div v-if="showLoading" class="overlay">

			<div class="modal">

				<div class="success">

					<h2>✓ Verification Complete</h2>

					<p>Loading portfolio...</p>

					<div class="spinner"></div>

				</div>

			</div>

		</div>

	</div>

</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "VerificationJoke",
	data() {
		return {
			showOverlay: false,
			images: [
				"/src/img/verification/1.jpg",
				"/src/img/verification/2.jpg",
				"/src/img/verification/3.jpg",
				"/src/img/verification/4.jpg",
				"/src/img/verification/5.jpg",
				"/src/img/verification/6.jpg",
				"/src/img/verification/7.jpg",
				"/src/img/verification/8.jpg",
				"/src/img/verification/9.jpg",
			],
			selected: [] as string[],
			error: "",
			prompts: [
				{
					question: "the next gameplay programmer you want to hire",
				},
				// {
				// 	question: "an excellent hiring decision",
				// },
			],
			promptStage: 0,
			showLoading: false,
			verified: false
		};
	},
	mounted()
	{
		this.showOverlay = false;
		this.selected = [];
		this.error = "";
		this.showLoading = false;
		this.promptStage = 0;
		this.verified = false;
	},
	methods:
	{
		openChallenge()
		{
			this.showOverlay = true;
		},
		shuffleArray()
		{
			for (let i = this.images.length - 1; i > 0; i--) {

				const j = Math.floor(Math.random() * (i + 1));

				[this.images[i], this.images[j]] =
					[this.images[j], this.images[i]];
			}

			this.selected = [];
			this.error = "";
		},
		submitPrompt()
		{
			if (this.selected.length === 0)
			{
				this.error =
					"Please select at least one image before continuing.";
				return false;
			}

			this.promptStage++;
			if (this.promptStage <= this.prompts.length - 1)
			{
				this.shuffleArray();
				return false;
			}
			this.showOverlay = false;
			this.showLoading = true;

			setTimeout(() => {
				this.verified = true;
				this.$emit("verified");
			}, 3000);

			return true;
		},
		toggleSelectionImage(imageUrl: string)
		{
			if (this.selected.includes(imageUrl)) {
				this.selected = this.selected.filter(i => i !== imageUrl);
			} else {
				this.selected.push(imageUrl);
			}

			this.error = "";
		}
	}
});
</script>

<style scoped>
.container {
	max-width: 600px;
	margin: 120px auto;
	background: white;
	padding: 40px;
	border-radius: 8px;
	box-shadow: 0 2px 12px rgba(0,0,0,0.08);
	font-family: "Segoe UI", Arial;
    width: 90%;
}

.header {
	font-size: 24px;
	margin-bottom: 20px;
}

.check {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px;
	border: 1px solid #ddd;
	border-radius: 6px;
	cursor: pointer;
}

.checkbox {
	width: 24px;
	height: 24px;
	border: 2px solid #999;
	border-radius: 4px;
}

.footer {
	margin-top: 30px;
	color: #777;
	font-size: 14px;
}

.overlay {
	position: fixed;
	inset: 0;
	background: rgba(0,0,0,0.45);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.modal {
	width: 340px;
	background: white;
	border-radius: 4px;
	overflow: hidden;
	box-shadow: 0 2px 12px rgba(0,0,0,.25);
}

.challenge-header {
	background: #4285f4;
	color: white;
	padding: 12px;
}

.challenge-header h2 {
	margin: 0;
	font-size: 13px;
}

.challenge-header p {
	margin: 0;
	font-size: 20px;
	font-weight: 600;
}

.grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1px;
	background: #ddd;
	padding-top: 1px;
}

.grid img {
	width: 100%;
	aspect-ratio: 1;
	object-fit: cover;
	cursor: pointer;
	border: 3px solid transparent;
}

.grid img.selected {
	border-color: #4285f4;
}

.modal-footer {
	padding: 10px;
	display: flex;
	justify-content: flex-end;
}

button {
	background: #4285f4;
	color: white;
	border: none;
	padding: 8px 16px;
	font-size: 13px;
	cursor: pointer;
}

.error {
	color: #d93025;
	font-size: 13px;
	padding: 10px;
	background: #fce8e6;
	border-top: 1px solid #f5c6cb;
}

.spinner {
	width: 32px;
	height: 32px;
	margin: 20px auto 0;
	border: 4px solid #e0e0e0;
	border-top: 4px solid #4285f4;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

.success {
    padding: 30px;
    text-align: center;
}

.success h2 {
    color: #34a853;
    margin-top: 0;
}

@keyframes spin {
	from { transform: rotate(0deg); }
	to { transform: rotate(360deg); }
}

.grid img {
	width: 100%;
	aspect-ratio: 1;
	object-fit: cover;
	cursor: pointer;
	border: 3px solid transparent;
	transition: transform 0.15s ease;
}

.image-wrapper {
	position: relative;
	background: white;
	overflow: hidden;
}

.image-wrapper.selected img {
	transform: scale(0.9);
}

.checkmark {
	position: absolute;
	top: 8px;
	left: 8px;
	width: 28px;
	height: 28px;
	background: #4285f4;
	color: white;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 18px;
	z-index: 2;
}
</style>